var _defs, _path, _line, _line2, _line3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n      fill: none;\n      stroke: #FFFFFF;\n      stroke-width: 2px;\n      }\n\n      .cls-1 {\n      stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      }\n    "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.10633,48V45.25532a2.21277,2.21277,0,0,1,2.21277-2.21277h6.10938a2.3921,2.3921,0,0,0,2.32663-2.4654v.04534c.00015-.05884.00025-3.157.0003-3.26864a1.83426,1.83426,0,0,1,.45829-1.145A2.91174,2.91174,0,0,0,41.926,34.283l-.00671-.667a1.01577,1.01577,0,0,1,.651-.95246h1.06717a1.36279,1.36279,0,0,0,1.051-.45576,1.30383,1.30383,0,0,0,.18991-1.39467,67.03163,67.03163,0,0,1-3.03774-7.51068,4.76727,4.76727,0,0,1-.217-1.506l-.00116-4.99479a14.51307,14.51307,0,0,0-.55236-3.96247l-.00629-.02213a13.959,13.959,0,0,0-3.13693-5.70178q-.47888-.51632-1.00575-1.00351c-.22028-.21208-.44471-.42091-.67748-.62277A18.30309,18.30309,0,0,0,24.19349,1a19.61682,19.61682,0,0,0-12.538,4.489A17.555,17.555,0,0,0,7.7101,27.17965C9.94456,31.506,11.69423,38.6214,12.1396,46v2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.91667,
    x2: 31.41667,
    y1: 12,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.91667,
    x2: 31.41667,
    y1: 26,
    y2: 26
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.66667,
    x2: 29.66667,
    y1: 12,
    y2: 26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "23.992 26 19.904 12 19.226 12 15.159 26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.85387,
    x2: 22.27596,
    y1: 21.13313,
    y2: 21.13313
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatIcon);
export default __webpack_public_path__ + "static/media/aiChatIcon.9a53e7c05e9281e07b6281f5fcbfd1c8.svg";
export { ForwardRef as ReactComponent };